"use client";

import { useState } from "react";

import { authorizeKakao } from "@/shared/auth/kakao";

/**
 * 카카오 로그인 훅 (리다이렉트 방식)
 *
 * authorizeKakao()로 카카오 로그인 페이지로 리다이렉트.
 * 콜백 처리는 /register/login 페이지에서 수행.
 */
export function useKakaoAuth() {
  const [isLoading, setIsLoading] = useState(false);

  function handleLogin() {
    setIsLoading(true);
    authorizeKakao();
    // 리다이렉트되므로 이 이후 코드는 실행되지 않음
  }

  return { isLoading, handleLogin };
}
